import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import API from '../../api';
import { ModalProjectAction, PageHeader } from '../../components';
import { SnackbarContext } from '../../contexts';
import { modalStyle } from '../../styles/style';
import { ProjectForm } from './form/components/ProjectForm';
import { useProject } from './hooks';

export const ProjectWritingPage = (props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { slug } = useParams();
  const { updateSnackbar } = useContext(SnackbarContext);

  const { project, getProject } = useProject();

  useEffect(() => {
    if (slug) {
      getProject();
    }
  }, [slug]);

  //보완 완료용 모달
  const [actionOpen, setActionOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedNextAction, setSelectedNextAction] = useState(null);

  const closeActionModal = () => {
    setActionOpen(false);
    setSelectedAction(null);
    setSelectedNextAction(null);
  };

  const handleModalRequest = useCallback(
    (body) => {
      API.Project.PostNextAction(slug, {
        nextAction: selectedNextAction === 'ImproveProjectComplete' ? 'ImproveProjectComplete' : 'ProjectSubmit',
      }).then(
        (res) => {
          let result = res.data;
          console.log('PostNextAction  result', result);
          history.push('/request_complete?type=project');
        },
        (err) => {
          updateSnackbar({
            type: 'error',
            open: true,
            message: err.data.message,
          });
        },
      );
    },
    [slug, selectedNextAction, project],
  );

  return (
    <article className='basic-page'>
      <PageHeader title={t('PROJECT')} type='project' />
      <article className='block'>
        <ProjectForm
          project={project}
          setActionOpen={setActionOpen}
          setSelectedAction={setSelectedAction}
          setSelectedNextAction={setSelectedNextAction}
        />
      </article>
      <Modal open={actionOpen} onClose={closeActionModal}>
        <Box sx={modalStyle}>
          <ModalProjectAction
            action={selectedAction}
            nextAction={selectedNextAction}
            requestAction={handleModalRequest}
            onClose={closeActionModal}
          ></ModalProjectAction>
        </Box>
      </Modal>
    </article>
  );
};
